// Módulos adicionales: GPS, sensor táctil y láser.
import { definePart, PITCH } from './registry.js';

export const GPS = { w: 25, d: 36, pcbY: 1.6, t: 1.6 };

definePart({
  type: 'gps-neo6m',
  name: 'GPS NEO-6M',
  category: 'comunicacion',
  description: 'Módulo GPS u-blox: cada segundo manda por serie (9600 baudios) frases NMEA con posición, hora y velocidad (librería TinyGPS++).',
  keywords: 'gps neo-6m ublox nmea tinygps posicion latitud longitud satelite',
  props: [
    { key: 'lat', label: 'Latitud (°)', type: 'number', default: 19.4326, min: -90, max: 90, step: 0.0001, runtime: true },
    { key: 'lon', label: 'Longitud (°)', type: 'number', default: -99.1332, min: -180, max: 180, step: 0.0001, runtime: true },
    { key: 'alt', label: 'Altitud (m)', type: 'number', default: 2240, min: -400, max: 9000, step: 1, runtime: true },
    { key: 'speed', label: 'Velocidad', type: 'slider', min: 0, max: 150, step: 0.5, default: 0, unit: 'km/h', runtime: true },
    { key: 'course', label: 'Rumbo', type: 'slider', min: 0, max: 359, step: 1, default: 90, unit: '°', runtime: true },
    { key: 'sats', label: 'Satélites', type: 'slider', min: 0, max: 12, step: 1, default: 8, runtime: true },
  ],
  pins: ['VCC', 'RX', 'TX', 'GND'].map((name, i) => ({
    name,
    label: { VCC: 'VCC (3.3–5 V)', RX: 'RX (recibe del Arduino)', TX: 'TX (manda al Arduino)', GND: 'GND' }[name],
    kind: name === 'GND' ? 'gnd' : name === 'VCC' ? 'power' : 'signal',
    x: (i - 1.5) * PITCH,
    y: GPS.pcbY + GPS.t + 8.6,
    z: GPS.d / 2 + 1.2,
  })),
  footprint: { w: GPS.w + 1, d: GPS.d + 4, h: 12, z: 1 },
  help: 'Con menos de 3 satélites no hay posición (sin «fix»). TX del módulo va al pin RX del SoftwareSerial del sketch.',
});

definePart({
  type: 'touch-ttp223',
  name: 'Sensor táctil TTP223',
  category: 'entradas',
  description: 'Botón capacitivo: su salida I/O se pone en alto mientras lo tocas. Haz clic sostenido sobre el círculo.',
  keywords: 'touch tactil capacitivo ttp223 boton',
  props: [{ key: 'touched', label: 'Tocar el sensor', type: 'button' }],
  pins: ['GND', 'IO', 'VCC'].map((name, i) => ({
    name,
    label: { GND: 'GND', IO: 'I/O (salida)', VCC: 'VCC (2–5.5 V)' }[name],
    kind: name === 'GND' ? 'gnd' : name === 'VCC' ? 'power' : 'signal',
    x: (i - 1) * PITCH,
    y: 0,
    z: 7.5,
    insert: true,
  })),
  insertable: true,
  footprint: { w: 16, d: 17, h: 5, z: -1.5 },
});

definePart({
  type: 'laser-ky008',
  name: 'Módulo láser KY-008',
  category: 'luces',
  description: 'Diodo láser rojo de 650 nm: se enciende con 5 V en S (digitalWrite). En la escena se ve el haz.',
  keywords: 'laser ky-008 diodo rojo haz',
  pins: ['S', 'MID', 'GND'].map((name, i) => ({
    name,
    label: { S: 'S (señal: alimenta el láser)', MID: 'Centro (sin uso)', GND: '− (GND)' }[name],
    kind: name === 'GND' ? 'gnd' : 'signal',
    x: (i - 1) * PITCH,
    y: 0,
    z: 8,
    insert: true,
  })),
  insertable: true,
  footprint: { w: 17, d: 22, h: 10, z: -2 },
});

definePart({
  type: 'bmp280',
  name: 'Sensor de presión BMP280',
  category: 'sensores',
  description: 'Barómetro y termómetro por I²C (librería Adafruit_BMP280). Con la presión calcula la altitud. Dirección 0x76 (SDO a GND) o 0x77 (SDO a VCC).',
  keywords: 'bmp280 presion barometro altitud temperatura i2c bosch gy-bmp280',
  props: [
    { key: 'temperature', label: 'Temperatura', type: 'slider', min: -40, max: 85, step: 0.1, default: 22.5, unit: '°C', runtime: true, live: true },
    { key: 'pressure', label: 'Presión', type: 'slider', min: 300, max: 1100, step: 0.1, default: 1013.25, unit: 'hPa', runtime: true, live: true },
  ],
  pins: ['VCC', 'GND', 'SCL', 'SDA', 'CSB', 'SDO'].map((name, i) => ({
    name,
    label: { VCC: 'VCC (3.3 V)', GND: 'GND', SCL: 'SCL', SDA: 'SDA', CSB: 'CSB (alto = I²C)', SDO: 'SDO (dirección)' }[name],
    kind: name === 'GND' ? 'gnd' : name === 'VCC' ? 'power' : 'signal',
    x: (i - 2.5) * PITCH,
    y: 0,
    z: 4.5,
    insert: true,
  })),
  insertable: true,
  footprint: { w: 16, d: 13, h: 5, z: -1.5 },
});
